<template>
  <div>
    <div class="pagination is-justify-content-center">
      <button id="botaoanterior" class="item prev" :class="btnPaginaAnteriorClass()" @click="_anterior(this.pagina)" :title="btnPaginaAnteriorTitle()">Anterior</button>
      <button
        class="item"
        v-for="page in this.totalPaginas"
        :key="page"
        @click="this.changePage(page)"
        :id="`pagina-${page}`"
        :title="btnPaginaTitle(page)"
      >
        {{ page }}
      </button>
      <button id="botaoproximo" class="item next" @click="_proxima(this.pagina)" :class="btnProximaPaginaClass()" :title="btnProximaPaginaTitle()">Próxima</button>
      <button id="botaoAdicao" class="item" @click="this.isPaginacaoAvancadaVisivel = !this.isPaginacaoAvancadaVisivel" title="Paginação avançada...">
        <i class="mdi mdi-plus-thick mdi-18px" aria-hidden="true"></i>
      </button>
    </div>
    <div v-if="this.isPaginacaoAvancadaVisivel" class="paginacao-avancada">
      <div class="pagination">
        <button id="botaoprimeiro" class="item first has-text-primary" @click="_primeira">
          <i class="mdi mdi-arrow-left-thick mdi-18px vertical-align-middle" aria-hidden="true"></i>Primeira página
        </button>

        <p class="totalizador-itens my-auto px-4">Total: {{ this.total }} itens</p>

        <div>
          <input
            id="inputPagina"
            class="input is-flex-grow-1"
            placeholder="página"
            min="1"
            v-model="this.inputPagina"
            @keypress="isNumero"
          />
          <span
            id="buscarPorPagina"
            class="button"
            @click="this.buscarPorPagina()"
            ><i class="mdi mdi-map-marker"></i>Ir!
          </span>
        </div>
      
        <div class="select mx-4">
          <select
            class="is-hovered"
            @change="changeLimite(parseInt($event.target.value))"
            id="selectLimit"
          >
            <option disabled selected>Itens por página</option>
            <option
              v-for="(option, index) in this.options"
              :id="`limite-${index}`"
              :key="index"
              :value="option"
            >
              {{ option }}
            </option>
          </select>
        </div>
      
        <button id="botaoultimo" class="item last has-text-primary" @click="_ultima" :title="btnUltimaPaginaTitle()">
          Última página<i class="mdi mdi-arrow-right-thick mdi-18px vertical-align-middle" aria-hidden="true"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TrfPagination",
  props: {
    total: {
      type: [String, Number],
      required: true,
      default: 0,
    },
    quantidadeDeItemsExibindo: {
      type: [String, Number],
      required: true,
      default: 1,
    },
    paginaSelecionada: {
      type: [String, Number],
      required: false,
      default: 1
    },
    limiteAtual: {
      type: [String, Number],
      required: false,
      default: 10
    }
  },
  data() {
    return {
      start_paginacao: 0,
      end_paginacao: 10,
      pagina: this.paginaSelecionada,
      limit: this.limiteAtual,
      options: [10, 20, 30, 50, 100],
      isPaginacaoAvancadaVisivel: false,
      totalPaginas: [],
      inputPagina: "",
      tooltipPaginaAnterior: "Não há página anterior!"
    };
  },
  methods: {
    pages(start_paginacao, end_paginacao) {
      const qty = this._calcularUltimaPagina();
      if (qty <= 1) {
        this.totalPaginas = [1];
        return this.totalPaginas;
      }

      this.totalPaginas = Array.from(Array(qty).keys(), (i) => i + 1).slice(
        start_paginacao,
        end_paginacao
      );
      return this.totalPaginas;
    },
    changePage(offset) {
      if(this.pagina == offset && this.limit == this.limiteAtual) return;

      if (this.pages.length > 1) {
        this.pagina = offset;
        this.$emit("changePage", offset);
      }
      this._paginarDeDezEmDez(this.pagina);
    },
    buscarPorPagina() {
      let pagina = this.inputPagina == 0 ? 1 : parseInt(this.inputPagina);
      const ultimaPagina = this._calcularUltimaPagina();
        
      this.inputPagina = "";
      this.isPaginacaoAvancadaVisivel = false;

      let novaPagina = pagina > ultimaPagina ? ultimaPagina : pagina;
      this.changePage(novaPagina);
    },
    _focarEDesfocar(pagina) {
      let div = document.getElementById(`pagina-${pagina}`) || document.querySelector('[id*="pagina-"]');
      const class_focada = document.getElementsByClassName("item foco");
      if (class_focada.length >= 1) {
        class_focada[0].classList.remove("foco");
      }

      if(!!div) {
        div.classList.add("foco");
      }
    },
    changeLimite(limit) {
      this.limit = limit;
      this.$emit("changeLimite", limit);
      this._primeira();
      this._paginarDeDezEmDez(this.pagina);
    },
    _primeira() {
      if (this.pagina >= 1) {
        this.changePage(1);
      }
    },

    _ultima() {
      let ultimaPagina = this._calcularUltimaPagina();
      if (this.pagina < ultimaPagina) {
        this.changePage(ultimaPagina);
      }
    },
    _proxima(pagina) {
      if (this.pagina < this._calcularUltimaPagina()) {
        this.changePage(parseInt(pagina) + 1);
      }
    },
    _anterior(pagina) {
      if (this.pagina > 1) {
        this.changePage(pagina - 1);
      }
    },

    _calcularUltimaPagina() {
      return Math.ceil(this.total / this.limit);
    },
    _paginarDeDezEmDez(pagina) {
      let ultimaPagina = this._calcularUltimaPagina();
      
      if(ultimaPagina <= 10 || pagina <= 5) {
        this.start_paginacao = 0;
        this.end_paginacao = 10;
      } else if (ultimaPagina - (pagina + 4) <= 0) {
        this.start_paginacao = ultimaPagina - 10;
        this.end_paginacao = ultimaPagina;
      } else if (pagina >= 6) {
        this.start_paginacao = pagina - 5;
        this.end_paginacao = pagina + 5;
      }
      
      this.pages(this.start_paginacao, this.end_paginacao);
    },

    isNumero(e) {
      e = (e) ? e : window.event;
      let charCode = (e.which) ? e.which : e.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        e.preventDefault();
      } else {
        return true;
      }
    },

    btnUltimaPaginaTitle() {
      let ultimaPagina = this._calcularUltimaPagina();
      return `Página ${ultimaPagina}...`
    },
    btnProximaPaginaClass() {
      return this.pagina >= this._calcularUltimaPagina() ? "desabilitado" : "";
    },
    btnPaginaAnteriorClass() {
      return this.pagina <= 1 ? "desabilitado" : "";
    },
    btnPaginaTitle(pagina) {
      return this.pagina == pagina ? "Você está nessa página" : `Ir para página ${pagina}`;
    },
    btnPaginaAnteriorTitle() {
      return this.pagina == 1 ? "Não há página anterior!" : "Página anterior";
    },
    btnProximaPaginaTitle() {
      let ultimaPagina = this._calcularUltimaPagina();
      return ultimaPagina == this.pagina ? "Não há próxima página!" : "Próxima página";
    }
  },
  watch: {
    total() {
      this._paginarDeDezEmDez(this.pagina);
      this._focarEDesfocar(this.pagina);
    },
    paginaSelecionada: {
      immediate: true,
      handler() {
        if(this.paginaSelecionada) {
          this.pagina = this.paginaSelecionada;
        }
        
        this._paginarDeDezEmDez(this.pagina);
      }
    },
    limiteAtual: {
      immediate: true,
      handler() {
        if(this.limiteAtual) {
          this.limite = this.limiteAtual;
        }
      }
    },
  },
  mounted() {
    this.pages(this.start_paginacao, this.end_paginacao);
  },
  updated() {
    this._focarEDesfocar(this.pagina);
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/sass/variables.scss";
$light-grey: #cccccc;
$dark-grey: #333333;
$orange: #f90;
$dark-orange: #f63;

#inputPagina {
  width: 50%;
  margin-right: -1px;
  border-radius: 4px 0 0 4px;
  border-color: lighten($dark-grey, 50%);
}
#buscarPorPagina {
  border-radius: 0 4px 4px 0;
  border-color: lighten($dark-grey, 50%);
}
#botaoAdicao {
  margin-left: 0.3rem;
  border-radius: 4px;
}
#botaoanterior {
  border-radius: 4px 0 0 4px;
  margin-right: -1px;
}
#botaoproximo {
  border-radius: 0 4px 4px 0;
  margin-left: -0.7px;
}
#botaoprimeiro,
#botaoultimo {
  border-radius: 15px;
  padding: 5px;
  width: auto;
  height: 32px;
  padding: 5px 11px;
}
.column {
  padding: 0;
}
.pagination {
  margin: 0 0 40px 0;
  display: flex;
  .item {
    padding: 6px 0.75rem;
    border: 1px solid $light-grey;
    cursor: pointer;
    background-color: white;
    color: var(--tertiaryColor, $tertiary);
    height: 34px;
    font-size: 14px;
    line-height: 20px;
    text-align: center;

    &:first-child {
      border-top-left-radius: 3px;
      border-bottom-left-radius: 3px;
    }
    &:last-child {
      border-top-right-radius: 3px;
      border-bottom-right-radius: 3px;
    }
    &:hover {
      background-color: $light-grey;
      border-color: lighten($dark-grey, 50%);
      z-index: 3;
    }
    &.current {
      cursor: default;
      color: var(--secondaryColor, $secondary);
      background-color: var(--primaryColor, $primary);
      border-color: var(--primaryColorLight, lighten($primary, 50%));
      z-index: 2;
    }
    + .item {
      margin-left: -0.063rem;
      margin-right: 0;
    }
  }
  .desabilitado {
    font-size: 14px;
    border: 0.063rem solid $light-grey;
    background-color: white;
    color: #b3b1b3;
    height: 2.125rem;
    line-height: 20px;
    cursor: not-allowed;
    
    &:hover {
      background-color: inherit;
      border-color: inherit;
      z-index: unset;
    }
  }
  .foco {
    background-color: var(--primaryColor, $primary);
    border-color: var(--primaryColorLight, lighten($primary, 50%));
    color: var(--secondaryColor, #FFF);
    &:hover {
      background-color: var(--primaryColor, $primary);
      border-color: var(--primaryColorLight, lighten($primary, 50%));
      z-index: unset;
    }
  }
  .select {
    height: 2.1rem;
  }
  #selectLimit {
    border-color: #b3b3b3;
    margin: 0 0 0.625rem 0;
  }
  .vertical-align-middle {
    vertical-align: middle;
  }
  .totalizador-itens {
    font-size: 14px;
  }
  .select:not(.is-multiple):not(.is-loading)::after {
    border-color: #333;
  }
}
</style>
